import { Injectable } from '@angular/core';

export interface LineItem {
  itemId: string;
  editionId?: string;
  itemType: 'app' | 'addon' | 'package';
  quantity: number;
}

const LINE_ITEMS_CACHE_KEY = 'inventory/line-items-cache';

@Injectable()
export class LineItemCacheService {
  private buildKey(businessId: string): string {
    return `${LINE_ITEMS_CACHE_KEY}:${businessId}`;
  }

  readLineItems(businessId: string): LineItem[] {
    const key = this.buildKey(businessId);
    const lineItems = sessionStorage.getItem(key);
    if (!lineItems?.length) return [];

    return JSON.parse(lineItems);
  }

  cacheLineItems(businessId: string, lineItems: LineItem[]): void {
    const key = this.buildKey(businessId);
    if (!lineItems?.length) {
      sessionStorage.removeItem(key);
      return;
    }

    sessionStorage.setItem(key, JSON.stringify(lineItems));
  }

  clearLineItemCache(businessId: string): void {
    const key = this.buildKey(businessId);
    sessionStorage.removeItem(key);
  }
}
